declare var swal: any;
import { Component, Input, OnInit } from '@angular/core';
import { ActorContactInfoRequest, ActorContactInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppData } from '../../../../models/appdata';
import { NgbContactInfoModal } from './modals/ngbcontactinfo.modal';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';


@Component({
  selector: 'contactinfo',
  templateUrl: './contactinfo.component.html',
  styleUrls: ['./contactinfo.component.scss']
})

export class ContactInfoComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  public isRequesting: boolean = false;
  CurrentActorContactInfoRequest: ActorContactInfoRequest;
  CurrentActorContactInfoController: ActorContactInfoController;

  public ApiResData: ApiResponseModel;

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.CurrentActorContactInfoRequest = new ActorContactInfoRequest();
    this.CurrentActorContactInfoController = new ActorContactInfoController();
    this.CurrentActorContactInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorContactInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorContactInfoController();
    }

  }
  GetActorContactInfoController() {
   
    this.StartRefreshing();
    this.hcpservice.GetActorContactInfoController(this.CurrentActorContactInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
        
          this.CurrentActorContactInfoController = this.ApiResData.Result[0];
         
          console.log('this.CurrentActorContactInfoController ' + this.CurrentActorContactInfoController.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    if (this.CanEdit === 1) {
      this.CurrentActorContactInfoRequest.ConditionalOperator = 2;
      this.CurrentActorContactInfoRequest.ActorCode = this.CurrentActorContactInfoController.ActorCode;
      this.CurrentActorContactInfoRequest.AddressLine1 = this.CurrentActorContactInfoController.AddressLine1;
      this.CurrentActorContactInfoRequest.AddressLine2 = this.CurrentActorContactInfoController.AddressLine2;
      this.CurrentActorContactInfoRequest.City = this.CurrentActorContactInfoController.City;
      this.CurrentActorContactInfoRequest.State = this.CurrentActorContactInfoController.State;
      this.CurrentActorContactInfoRequest.Country = this.CurrentActorContactInfoController.Country;
      this.CurrentActorContactInfoRequest.Telephone1 = this.CurrentActorContactInfoController.Telephone1;
      this.CurrentActorContactInfoRequest.Telephone2 = this.CurrentActorContactInfoController.Telephone2;
      this.CurrentActorContactInfoRequest.Fax1 = this.CurrentActorContactInfoController.Fax1;
      this.CurrentActorContactInfoRequest.Fax2 = this.CurrentActorContactInfoController.Fax2;
      this.CurrentActorContactInfoRequest.Email = this.CurrentActorContactInfoController.Email;
      this.CurrentActorContactInfoRequest.EmergencyContactPersonName = this.CurrentActorContactInfoController.EmergencyContactPersonName;
      this.CurrentActorContactInfoRequest.EmergencyContactNo1 = this.CurrentActorContactInfoController.EmergencyContactNo1;
      this.CurrentActorContactInfoRequest.EmergencyContactNo2 = this.CurrentActorContactInfoController.EmergencyContactNo2;
      this.CurrentActorContactInfoRequest.EmergencyAddress = this.CurrentActorContactInfoController.EmergencyAddress;

      const modalRef = this.modalService.open(NgbContactInfoModal)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.CurrentActorContactInfoRequest = this.CurrentActorContactInfoRequest;
      modalRef.result.then(x => { this.GetActorContactInfoController() })
    }
    else {
      alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
    }

  }



}
